
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contentful-preview/projects/[slug]",
      function () {
        return require("private-next-pages/contentful-preview/projects/[slug].page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contentful-preview/projects/[slug]"])
      });
    }
  